import React, { useContext } from 'react';
import styles from '../../css/components/ipp/ippButtons.css';
import { OneLPSsdkParamsContext } from '../../onelps-sdk-params-context';
import IppButton from './IppButton';
import PropTypes from 'prop-types';

export const IPP_BUTTONS_STYLE = {
	INGAME: 'ingame',
	MAIN_FORM: 'mainForm',
	LOGIN_FORM: 'loginForm'
};

function IppButtons({
	captionText = null,
	captionPosition = 'left',
	cookieNotificationValue,
	onLinkClick,
	style,
}) {
	const onelpsParams = useContext(OneLPSsdkParamsContext);
	const gameId = onelpsParams.gameId;
	const pageType = onelpsParams.pageType;

	const useLargeIpp = (gameId === 'foe' && pageType === 'ingame') || onelpsParams.form?.ippPosition === 'aboveTerms';
	const listClassNames = useLargeIpp ?
		`${styles.ippButtons} ${styles['ippLarge']}` :
		styles.ippButtons;

	return (
		<div className={`${styles[onelpsParams.gameId]} ${styles[style]} ${styles.ippWithCaptionWrapper} ${styles[captionPosition]}`}>
			{captionText && (
				<div className={styles.captionText}>
					<span data-testid="ipp-caption">
						{captionText}
					</span>
				</div>
			)}
			<ul className={listClassNames}>
				{onelpsParams.ippLinks.map((ippItem, i) => (
					<li key={i}>
						<IppButton
							providerName={ippItem.name}
							baseProviderUrl={ippItem.url}
							isSkippingNickname={ippItem.isSkippingNickname}
							cookieNotificationValue={cookieNotificationValue}
							onLinkClick={onLinkClick}
							parentForm={style}
						/>
					</li>
				))}
			</ul>

		</div>
	);
}

export default IppButtons;

IppButtons.propTypes = {
	hasCaption: PropTypes.bool,
	cookieNotificationValue: PropTypes.string.isRequired,
	onLinkClick: PropTypes.func.isRequired,
	style: PropTypes.oneOf(Object.values(IPP_BUTTONS_STYLE)).isRequired,
	captionPosition: PropTypes.string,
	captionText: PropTypes.string,
};
